<template>
    <div>
            <v-container>
                <v-card-title>
                    <span class="display-1">Horno</span>
                    <v-spacer></v-spacer>
                </v-card-title>
                <v-card-subtitle style="font-weight:bold; font-size:17px; text-align:center;" class="mt-6">
                    
                    <grafica-lineal
                        :data="data"
                        title="Temperatura" 
                        style="height: 100%;width: 100%; max-height: 500px;"                   >
                    </grafica-lineal>

                    <v-row>
                        <v-col class="mt-5">
                            <v-label class="subtitle-1 font-weight-bold">Tiempo restante de ciclo: </v-label>
                            <span class="subtitle-1">{{ tiempoRestante }}</span>
                        </v-col>
                        <v-col>

                            <v-container class="fill-height d-flex justify-center align-center">
                                <v-card
                                    :color="alarmColor"
                                    class="d-flex justify-center align-center"
                                    width="200"
                                    height="50"
                                    tile
                                >   
                                    <v-icon large color="white">mdi-bell-alert</v-icon>
                                    <span style="margin-left: 2%;" class="white--text">Sobretemperatura</span>
                                </v-card>
                                <v-card
                                    :color="alarmColorComb"
                                    class="d-flex justify-center align-center"
                                    width="200"
                                    height="50"
                                    tile
                                    style="margin-left: 5%;"
                                >
                                    <v-icon large color="white">mdi-bell-alert</v-icon>
                                    <span style="margin-left: 2%;" class="white--text">Fallo combustión</span>
                                </v-card>
                                </v-container>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-btn color="primary" @click="toggleDialogVisibleTemp">
                                Histórico temperaturas
                            </v-btn>

                        </v-col>
                        <v-col>
                            
                            <v-btn color="primary" @click="toggleDialogVisibleAlarm">
                                Histórico alarmas
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-subtitle>
              <v-dialog  fullscreen  overflow-y ="hidden"
              overflow-x= "hidden" v-model="dialogVisibleTemp" persistent >                
                <v-card text-center class="mt-2 pr-3" style="overflow-x: hidden;" >
                    <v-card-title>
                    <span class="display-1">Consultar histórico temperaturas</span>
                    </v-card-title>
                    <v-row class="mt-1 justify-center" >
                        <v-col cols="1" md="2" sm="3">
                            <v-card-title> Filtrar:</v-card-title>
                        </v-col>
                        <!-- Fecha de inicio -->
                        <v-col :class="pantalla <500?'':''" >
                            <v-menu v-model="fechaInicioInput" :close-on-content-click="false" 
                            :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="fechaInicio"
                                        label="Fecha Inicio"
                                        prepend-icon="mdi-calendar"
                                        v-bind="attrs"
                                        v-on="on"
                                        ></v-text-field>
                                </template>
                                <v-date-picker v-model="fechaInicio" @input="fechaInicioInput = false"></v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col >
                            <v-text-field
                                v-model="horaInicioTemperatura"
                                label="Hora Inicio"
                                type="time"
                            ></v-text-field>
                        </v-col>
                        <!-- Fecha fin -->
                        <v-col>
                            <v-menu v-model="fechaFinInput" :close-on-content-click="false" 
                            :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                v-model="fechaFin"
                                label="Fecha Fin"
                                prepend-icon="mdi-calendar"
                                v-bind="attrs"
                                v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker v-model="fechaFin" @input="fechaFinInput = false"></v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col >
                            <v-text-field
                                v-model="horaFinTemperatura"
                                label="Hora Fin"
                                type="time"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="1" md="1" sm="2" class="mr-1"> 
                            <v-btn :class="pantalla < 500? 'ml-3 mb-2':'mt-3'" :block="pantalla < 500" color="primary" @click="historicoTemperaturasFiltradoFunction">
                                <v-icon>mdi-magnify</v-icon>
                            </v-btn>
                        </v-col>
                        <v-col cols="1" md="1" sm="2" class="mr-1"> 
                            <v-btn :class="pantalla < 500? 'ml-3 mb-2':'mt-3'" :block="pantalla < 500" color="green" @click="verGrafico">
                                <v-icon color="white">mdi-chart-line</v-icon>
                            </v-btn>
                        </v-col>
                        <v-col >
                            <v-btn 
                                :class="pantalla < 500 ? 'ml-3 mb-2' : 'mt-3'" 
                                :block="pantalla < 500" 
                                color="green" 
                                @click="exportarExcelTemperaturas"
                            >
                                <v-icon color="white" >mdi-file-excel</v-icon>
                            </v-btn>
                        </v-col>
                        <v-col cols="1" md="1" sm="2" class="mr-1"> 
                            <v-btn :class="pantalla < 500? 'ml-3 mb-2':'mt-3'" :block="pantalla < 500" color="primary" @click="resetFiltrosTemperaturas">
                                atrás
                            </v-btn>
                        </v-col>
                        <v-container v-if="verGrafica">

                            <grafica-lineal v-if="verGrafica"
                                :data="dataFiltrada"
                                title="Temperatura" 
                                style="height: 500px;width: 100px; max-height: 500px;"                   >
                            </grafica-lineal>
                        </v-container>
                            
                    
                        
                    </v-row>
                    <v-data-table :items="historicoTemperaturasFiltrado" :headers="headers" :loading="loading" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :search="search" 
                                :footer-props="{
                                    'items-per-page-text':'Temperaturas'
                                }">
                                 <template v-slot:item.fecha="{ item }">
                                    {{ formatearFechaHora(item.fecha) }}
                                </template>
                                <template v-slot:item.id_variable="{ item }">
                                    <span>Temperatura {{ item.id_variable }}</span>
                                    <!-- <span v-if="item.id_variable === 1">Temperatura 1</span>
                                    <span v-else-if="item.id_variable === 2">Temperatura 2</span>
                                    <span v-else-if="item.id_variable === 3">Temperatura 3</span>
                                    <span v-else-if="item.id_variable === 4">Temperatura 4</span>
                                    <span v-else-if="item.id_variable === 5">Temperatura 5</span>
                                    <span v-else-if="item.id_variable === 6">Temperatura 6</span> -->
                                </template>
                    </v-data-table>
                    <v-row>

                    </v-row>
                </v-card>
              </v-dialog>
              <v-dialog fullscreen v-model="dialogVisibleAlarm" persistent >
                <v-card text-center class="mt-2 pr-3" style="overflow-x: hidden;" >
                    <v-card-title>
                    <span class="display-1">Consultar histórico alarmas</span>
                    </v-card-title>
                    <v-row class=" justify-center">
                        <v-col cols="16" md="2" sm="3" >
                            <v-card-title> Filtrar:</v-card-title>
                        </v-col>
                        <v-col :class="pantalla <500?'':''" >
                            <v-menu v-model="fechaInicioInputAlarma" :close-on-content-click="false" 
                            :nudge-right="40" transition="scale-transition" offset-y>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="fechaInicioAlarma"
                                        label="Fecha Inicio"
                                        prepend-icon="mdi-calendar"
                                        v-bind="attrs"
                                        v-on="on"
                                        ></v-text-field>
                                </template>
                                <v-date-picker v-model="fechaInicioAlarma" @input="fechaInicioInputAlarma = false"></v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col >
                            <v-text-field
                                v-model="horaInicioAlarma"
                                label="Hora Inicio"
                                type="time"
                            ></v-text-field>
                        </v-col>
                        <v-col :class="pantalla <500?'':''" >
                            <v-menu v-model="fechaFinInputAlarma" :close-on-content-click="false" 
                            :nudge-right="40" transition="scale-transition" offset-y min-width="auto" >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                v-model="fechaFinAlarma"
                                label="Fecha Fin"
                                prepend-icon="mdi-calendar"
                                v-bind="attrs"
                                v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker v-model="fechaFinAlarma" @input="fechaFinInputAlarma = false"></v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col >
                            <v-text-field
                                v-model="horaFinAlarma"
                                label="Hora Inicio"
                                type="time"
                            ></v-text-field>
                        </v-col>
                        <v-col  cols="4" md="1" sm="2" class="mr-3"> 
                            <v-btn :class="pantalla < 500? 'ml-3 mb-2':'mt-3'" :block="pantalla < 500" color="primary" @click="filtrarAlarmas">
                                <v-icon>mdi-magnify</v-icon>
                            </v-btn>
                        </v-col>
                        <v-col cols="4" md="1" sm="2" class="mr-3">
                            <v-btn 
                                :class="pantalla < 500 ? 'ml-3 mb-2' : 'mt-3'" 
                                :block="pantalla < 500" 
                                color="green" 
                                @click="exportarExcelAlarmas"
                            >
                                <v-icon color="white" >mdi-file-excel</v-icon>
                            </v-btn>
                        </v-col>
                        <v-col  cols="4" md="1" sm="2" class="mr-3"> 
                            <v-btn :class="pantalla < 500? 'ml-3 mb-2':'mt-3'" :block="pantalla < 500" color="primary" @click="resetFiltrosAlarmas">
                                atrás
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-data-table :items="historicoAlarmasFiltrado" :headers="headersAlarma" :loading="loading" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :search="search" 
                                :footer-props="{
                                    'items-per-page-text':'Alarmas'
                                }">
                                <template v-slot:item.fecha="{ item }">
                                    {{ formatearFechaHora(item.fecha) }}
                                </template>
                                <template v-slot:item.valor="{ item }">
                                    {{ item.valor == 1 ? 'Encendida' : 'Apagada' }}
                                </template>
                    </v-data-table>
                </v-card>
              </v-dialog>
            </v-container>
        
        <div class="mt-4 text-subtitle-2"></div>
    </div>
</template>
<script>
import GraficaLineal from '../plugins/graficolineal/GraficaLineal.vue'
import moment from 'moment';
import mqtt from 'mqtt'
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { mapActions } from 'vuex';

export default {
    name: 'HornoComponent',
    components: {
        GraficaLineal
    },
    data() {
        return {
            alarmColor: "grey",
            alarmColorComb: "grey",
            dialogVisibleTemp: false,
            dialogVisibleAlarm: false,
            verGrafica: false,
            tiempoRestante : null,
            historicoTemperaturas: [],
            historicoAlarmas: [],
            historicoTemperaturasFiltrado: [],
            historicoAlarmasFiltrado: [],
            headers: [
                { text: "Fecha", value: "fecha" },
                { text: "Temperatura", value: "temperatura" },
                { text: "Variable", value: "id_variable" },
            ],
            headersAlarma: [
                { text: "ID", value: "id" },
                { text: "Fecha", value: "fecha" },
                { text: "Estado", value: "valor" },
                { text: "Descripción", value: "descripcion" },
            ],
            loading: true,
            teorico: [],
            sortBy:"fecha",
            sortDesc:true,
            pantalla:null,
            search: '',
            fechaInicioInput: false,
            fechaFinInput: false,
            fechaInicioInputAlarma: false,
            fechaFinInputAlarma: false,
            estado:null,
            fechaInicio:  moment().format('YYYY-MM-DD'),
            fechaInicioAlarma: moment().format('YYYY-MM-DD'),
            fechaFin: moment().format('YYYY-MM-DD'),
            fechaFinAlarma: moment().format('YYYY-MM-DD'),
            horaInicioTemperatura: '00:00',
            horaFinTemperatura: '23:59',
            horaInicioAlarma: '00:00',
            horaFinAlarma: '23:59',
            dias: 0,
            horas: 0,
            minutos: 0,
            datosTemperatura:[],
            datosTemperatura2:[],
            datosTemperatura3:[],
            datosTemperatura4:[],
            datosTemperatura5:[],
            datosTemperatura6:[],
            datosTemperaturaFiltrados1:[],
            datosTemperaturaFiltrados2:[],
            datosTemperaturaFiltrados3:[],
            datosTemperaturaFiltrados4:[],
            datosTemperaturaFiltrados5:[],
            datosTemperaturaFiltrados6:[],
            chartData: {
                  animation: false,
                labels: [],
                datasets: [
                    {
                    label: 'Temperatura',
                    data: [],
                    borderColor: 'rgba(255,99,132,1)',
                    backgroundColor: 'rgba(255,99,132,0.2)',
                    fill: false,
                    },
                ],
            },
            chartDataFiltrada: {
                animation: false,
                labels: [],
                datasets: [
                    {
                    label: 'Temperatura',
                    data: [],
                    borderColor: 'rgba(255,99,132,1)',
                    backgroundColor: 'rgba(255,99,132,0.2)',
                    fill: false,
                    },
                ],
            }
        }
    },
    mounted() {   
        this.tiempoRestante = 
            `Dias: ${String(this.dias).padStart(2, '0')} ` +
            `Horas: ${String(this.horas).padStart(2, '0')} ` +
            `Minutos: ${String(this.minutos).padStart(2, '0')} `;    
        const client = mqtt.connect('wss://sakana.koiote.es:9002', {
            lientId: 'webclient_' + Math.random().toString(16).substr(2, 8),
            lean: false 
        });

    client.on('connect', () => {
        client.subscribe('alarma_temp',{ qos: 2 }, err => {
            if (!err) console.log('Suscripción exitosa')
        })
        client.subscribe('alarma_comb',{ qos: 2 }, err => {
            if (!err) console.log('Suscripción exitosa')
        })
        client.subscribe('temperatura_1',{ qos: 2 }, err => {
            if (!err) console.log('Suscripción exitosa')
        })
        client.subscribe('temperatura_2',{ qos: 2 }, err => {
            if (!err) console.log('Suscripción exitosa')
        })
        client.subscribe('temperatura_3',{ qos: 2 }, err => {
            if (!err) console.log('Suscripción exitosa')
        })
        client.subscribe('temperatura_4',{ qos: 2 }, err => {
            if (!err) console.log('Suscripción exitosa')
        })
        client.subscribe('temperatura_5',{ qos: 2 }, err => {
            if (!err) console.log('Suscripción exitosa')
        })
        client.subscribe('temperatura_6',{ qos: 2 }, err => {
            if (!err) console.log('Suscripción exitosa')
        })
        client.subscribe('dias',{ qos: 2 }, err => {
            if (!err) console.log('Suscripción exitosa')
        })
        client.subscribe('minutos',{ qos: 2 }, err => {
            if (!err) console.log('Suscripción exitosa')
        })
        client.subscribe('horas', err => {
            if (!err) console.log('Suscripción exitosa')
        })
    })
    client.on('message', (topic, message) => {
    let payload = message.toString(); // Convertimos el buffer a string    
    if (topic === 'dias') {
        this.dias = parseInt(payload, 10);
    } else if (topic === 'minutos') {
        this.minutos = parseInt(payload, 10);
    } else if (topic === 'horas') {
        this.horas = parseInt(payload, 10);
    }else if (topic === 'temperatura_1') {
        payload = JSON.parse(payload);
        const dateMadrid = moment.tz(payload.timestamp, 'UTC').tz('Europe/Madrid').toDate();
        if (payload.temperatura > -100) {
            this.datosTemperatura.push({ 
                x: dateMadrid, 
                y: payload.temperatura 
            });
        }
    }else if (topic === 'temperatura_2') {
        payload = JSON.parse(payload);
        const dateMadrid = moment.tz(payload.timestamp, 'UTC').tz('Europe/Madrid').toDate();
        if (payload.temperatura > -100) {
            this.datosTemperatura2.push({ 
                x: dateMadrid, 
                y: payload.temperatura 
            });
        }
    
    }else if (topic === 'temperatura_3') {
        payload = JSON.parse(payload);
        const dateMadrid = moment.tz(payload.timestamp, 'UTC').tz('Europe/Madrid').toDate();
        if (payload.temperatura > -100) {
        this.datosTemperatura3.push({ 
            x: dateMadrid, 
            y: payload.temperatura 
        });
    }
    
    } else if (topic === 'temperatura_4') {
        payload = JSON.parse(payload);
        const dateMadrid = moment.tz(payload.timestamp, 'UTC').tz('Europe/Madrid').toDate();
        if (payload.temperatura > -100) {
        this.datosTemperatura4.push({ 
            x: dateMadrid, 
            y: payload.temperatura 
        });
    }
    
    } else if (topic === 'temperatura_5') {
        payload = JSON.parse(payload);
        const dateMadrid = moment.tz(payload.timestamp, 'UTC').tz('Europe/Madrid').toDate();
        if (payload.temperatura > -100) {
        this.datosTemperatura5.push({ 
            x: dateMadrid, 
            y: payload.temperatura 
        });
    }
    
    } else if (topic === 'temperatura_6') {
        payload = JSON.parse(payload);
        const dateMadrid = moment.tz(payload.timestamp, 'UTC').tz('Europe/Madrid').toDate();
        if (payload.temperatura > -100) {
            this.datosTemperatura6.push({ 
                x: dateMadrid, 
                y: payload.temperatura 
            });
        }
    
    }  else if (topic === 'alarma_temp') {  
        payload = JSON.parse(payload); 
        if (payload.alarma == 1) {
            this.alarmColor = 'red';
        } else {
            this.alarmColor = 'grey';
        }
    }else if (topic === 'alarma_comb') { 
        payload = JSON.parse(payload);   
        if (payload.alarma == 1) {
            this.alarmColorComb = 'red';
        } else {
            this.alarmColorComb = 'grey';
        }
    }
    this.tiempoRestante = 
            `Dias: ${String(this.dias).padStart(2, '0')} ` +
            `Horas: ${String(this.horas).padStart(2, '0')} ` +
            `Minutos: ${String(this.minutos).padStart(2, '0')} `; 
});

    },
    computed: {
        data() {
        let datos = {
            labels: this.labels,
            datasets: [
                {
                    label: 'Temperatura1',
                    backgroundColor: 'rgba(255, 99, 132, 0.5)',  // rojo
                    borderColor: 'rgba(255, 99, 132, 1)',
                    data: this.datosTemperatura,
                    pointRadius: 0,
                },
                {
                    label: 'Temperatura2',
                    backgroundColor: 'rgba(54, 162, 235, 0.5)',  // azul
                    borderColor: 'rgba(54, 162, 235, 1)',
                    data: this.datosTemperatura2,
                    pointRadius: 0,
                },
                {
                    label: 'Temperatura3',
                    backgroundColor: 'rgba(255, 206, 86, 0.5)',  // amarillo
                    borderColor: 'rgba(255, 206, 86, 1)',
                    data: this.datosTemperatura3,
                    pointRadius: 0,
                },
                {
                    label: 'Temperatura4',
                    backgroundColor: 'rgba(75, 192, 192, 0.5)',  // verde
                    borderColor: 'rgba(75, 192, 192, 1)',
                    data: this.datosTemperatura4,
                    pointRadius: 0,
                },
                {
                    label: 'Temperatura5',
                    backgroundColor: 'rgba(153, 102, 255, 0.5)',  // morado
                    borderColor: 'rgba(153, 102, 255, 1)',
                    data: this.datosTemperatura5,
                    pointRadius: 0,
                },
                {
                    label: 'Temperatura6',
                    backgroundColor: 'rgba(255, 159, 64, 0.5)',  // naranja
                    borderColor: 'rgba(255, 159, 64, 1)',
                    data: this.datosTemperatura6,
                    pointRadius: 0,
                }
            ]

        }
        return datos
        },
        dataFiltrada() {
        let datos = {
            labels: this.labels,
            datasets: [
                {
                    label: 'Temperatura1',
                    backgroundColor: 'rgba(255, 99, 132, 0.5)',
                    borderColor: 'rgba(255, 99, 132, 1)',
                    
                    data: this.datosTemperaturaFiltrados1,
                    
                    pointRadius: 0, //No pintar los puntos (para que solo se vea la linea)
                },
                {
                    label: 'Temperatura2',
                    backgroundColor: 'rgba(54, 162, 235, 0.5)',  // azul
                    borderColor: 'rgba(54, 162, 235, 1)',
                    data: this.datosTemperaturaFiltrados2,
                    pointRadius: 0,
                },
                {
                    label: 'Temperatura3',
                    backgroundColor: 'rgba(255, 206, 86, 0.5)',  // amarillo
                    borderColor: 'rgba(255, 206, 86, 1)',
                    data: this.datosTemperaturaFiltrados3,
                    pointRadius: 0,
                },
                {
                    label: 'Temperatura4',
                    backgroundColor: 'rgba(75, 192, 192, 0.5)',  // verde
                    borderColor: 'rgba(75, 192, 192, 1)',
                    data: this.datosTemperaturaFiltrados4,
                    pointRadius: 0,
                },
                {
                    label: 'Temperatura5',
                    backgroundColor: 'rgba(153, 102, 255, 0.5)',  // morado
                    borderColor: 'rgba(153, 102, 255, 1)',
                    data: this.datosTemperaturaFiltrados5,
                    pointRadius: 0,
                },
                {
                    label: 'Temperatura6',
                    backgroundColor: 'rgba(255, 159, 64, 0.5)',  // naranja
                    borderColor: 'rgba(255, 159, 64, 1)',
                    data: this.datosTemperaturaFiltrados6,
                    pointRadius: 0,
                }
            ]
        }
        return datos
        },
    },
    methods: {
        ...mapActions('api', ['getHistoricosTemperaturas','getHistoricosTemperaturasByRange','getHistoricosAlarmasHorno','getHistoricosAlarmasByRange']),
        resetFiltrosTemperaturas() {
            this.historicoTemperaturasFiltrado = [];
            this.verGrafica = false;
            this.dialogVisibleTemp = false;
            this.fechaInicio = moment().format("YYYY-MM-DD");
            this.horaInicioTemperatura = "00:00";
            this.horaFinTemperatura = "23:59";
            this.fechaFin = moment().format("YYYY-MM-DD");
        },
        resetFiltrosAlarmas() {
            this.historicoAlarmasFiltrado = [];
            this.fechaInicioAlarma = moment().format("YYYY-MM-DD");
            this.horaInicioAlarma = "00:00";
            this.horaFinAlarma = "23:59";
            this.fechaFinAlarma = moment().format("YYYY-MM-DD");
            this.dialogVisibleAlarm = false;
        },
        exportarExcelAlarmas() {
        // Creamos un array con los datos en el orden deseado
        const datos = this.historicoAlarmasFiltrado.map(item => ({
            Fecha: this.formatearFechaHora(item.fecha),
            Alarma: item.descripcion, 
            Estado: item.valor == 1 ? 'Encendida' : 'Apagada',
        }));

        // Creamos una hoja de Excel
        const worksheet = XLSX.utils.json_to_sheet(datos);
        worksheet['!cols'] = [
            { wch: 25 },  // Fecha
            { wch: 50 },    // Descripcion
            { wch: 15 }   // Valor
        ];
        // Creamos un libro
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Alarmas");

        // Generamos el archivo
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: 'application/octet-stream' });
        saveAs(data, 'Alarmas.xlsx');
        },
        exportarExcelTemperaturas() {
        // Creamos un array con los datos en el orden deseado
        const datos = this.historicoTemperaturasFiltrado.map(item => ({
            Fecha: this.formatearFechaHora(item.fecha),
            Valor: item.temperatura,
            Variable: 'Temperatura ' + item.id_variable
        }));

        // Creamos una hoja de Excel
        const worksheet = XLSX.utils.json_to_sheet(datos);
        worksheet['!cols'] = [
            { wch: 25 },  // Fecha
            { wch: 15 },   // Valor
            { wch: 20 }    // Variable
        ];
        // Creamos un libro
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Temperaturas");

        // Generamos el archivo
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: 'application/octet-stream' });
        saveAs(data, 'temperaturas.xlsx');
        },
        verGrafico(){
            this.verGrafica = !this.verGrafica 
            this.datosTemperaturaFiltrados = []
            this.datosTemperaturaFiltrados1 = []
            this.datosTemperaturaFiltrados2 = []
            this.datosTemperaturaFiltrados3 = []
            this.datosTemperaturaFiltrados4 = []
            this.datosTemperaturaFiltrados5 = []
            this.datosTemperaturaFiltrados6 = []    
            this.historicoTemperaturasFiltrado.forEach(dato => {
                if (dato.id_variable == 1) {
                    this.datosTemperaturaFiltrados1.push({
                        y: dato.temperatura,
                        x: dato.fecha
                    })
                } else if (dato.id_variable == 2) {
                    this.datosTemperaturaFiltrados2.push({
                        y: dato.temperatura,
                        x: dato.fecha
                    })
                } else if (dato.id_variable == 3) {
                    this.datosTemperaturaFiltrados3.push({
                        y: dato.temperatura,
                        x: dato.fecha
                    })
                } else if (dato.id_variable == 4) {
                    this.datosTemperaturaFiltrados4.push({
                        y: dato.temperatura,
                        x: dato.fecha
                    })
                } else if (dato.id_variable == 5) {
                    this.datosTemperaturaFiltrados5.push({
                        y: dato.temperatura,
                        x: dato.fecha
                    })
                } else if (dato.id_variable == 6) {
                    this.datosTemperaturaFiltrados6.push({
                        y: dato.temperatura,
                        x: dato.fecha
                    })
                }
            })            
        },
        async toggleDialogVisibleTemp(){
            this.loading = true
            this.dialogVisibleTemp = !this.dialogVisibleTemp
            const inicioMadrid = moment.tz(
                `${this.fechaInicio} "00:00"}`,
                "YYYY-MM-DD HH:mm",
                "Europe/Madrid"
            );

            const finMadrid = moment.tz(
                `${this.fechaFin} "23:59"}`,
                "YYYY-MM-DD HH:mm",
                "Europe/Madrid"
            );
            const fechaInicioUTC = inicioMadrid.toISOString(); // objeto Date en UTC
            const fechaFinUTC = finMadrid.toISOString();
            const response = await this.getHistoricosTemperaturasByRange( {
                    fechaInicio: fechaInicioUTC,
                    fechaFin: fechaFinUTC,
                });
            this.historicoTemperaturas = response.data.map(item => ({
                id: item.id,
                temperatura: parseFloat(item.temperatura).toFixed(2),
                fecha: new Date(item.read_at),
                id_variable: item.id_variable
                }));
            this.historicoTemperaturasFiltrado = [...this.historicoTemperaturas]
            this.loading = false           
        },
        async toggleDialogVisibleAlarm(){
            this.loading = true
            this.dialogVisibleAlarm = !this.dialogVisibleAlarm
            const inicioMadrid = moment.tz(
                `${this.fechaInicioAlarma} "00:00"}`,
                "YYYY-MM-DD HH:mm",
                "Europe/Madrid"
            );

            const finMadrid = moment.tz(
                `${this.fechaFinAlarma} "23:59"}`,
                "YYYY-MM-DD HH:mm",
                "Europe/Madrid"
            );
            const fechaInicioUTC = inicioMadrid.toISOString(); // objeto Date en UTC
            const fechaFinUTC = finMadrid.toISOString();
            const response = await  this.getHistoricosAlarmasByRange( {
                    fechaInicio: fechaInicioUTC,
                    fechaFin: fechaFinUTC,
                });
            this.historicoAlarmas = response.data.map(item => ({
                id: item.id,
                valor : item.alarma,
                fecha : new Date(item.read_at),
                descripcion: item.descripcion
            }))            
            this.historicoAlarmasFiltrado = [...this.historicoAlarmas]            
            this.loading = false           
        },
        async historicoTemperaturasFiltradoFunction() {   
            if (!this.fechaInicio || !this.fechaFin){ return;}
            const inicioMadrid = moment.tz(
                `${this.fechaInicio} ${this.horaInicioTemperatura || "00:00"}`,
                "YYYY-MM-DD HH:mm",
                "Europe/Madrid"
            );

            const finMadrid = moment.tz(
                `${this.fechaFin} ${this.horaFinTemperatura || "23:59"}`,
                "YYYY-MM-DD HH:mm",
                "Europe/Madrid"
            );
            const fechaInicioUTC = inicioMadrid.toISOString(); // objeto Date en UTC
            const fechaFinUTC = finMadrid.toISOString();        

            try {
                this.loading = true
                const response = await  this.getHistoricosTemperaturasByRange( {
                    fechaInicio: fechaInicioUTC,
                    fechaFin: fechaFinUTC,
                });
                  
            this.historicoTemperaturas = response.data.map(item => ({
                id: item.id,
                temperatura: parseFloat(item.temperatura).toFixed(2),
                fecha: new Date(item.read_at),
                id_variable: item.id_variable
                }));
            this.historicoTemperaturasFiltrado = [...this.historicoTemperaturas]

            
            this.datosTemperaturaFiltrados = []
            this.datosTemperaturaFiltrados1 = []
            this.datosTemperaturaFiltrados2 = []
            this.datosTemperaturaFiltrados3 = []
            this.datosTemperaturaFiltrados4 = []
            this.datosTemperaturaFiltrados5 = []
            this.datosTemperaturaFiltrados6 = []  
            this.historicoTemperaturasFiltrado.forEach(dato => {
                if (dato.id_variable == 1) {
                    this.datosTemperaturaFiltrados1.push({
                        y: dato.temperatura,
                        x: dato.fecha
                    })
                } else if (dato.id_variable == 2) {
                    this.datosTemperaturaFiltrados2.push({
                        y: dato.temperatura,
                        x: dato.fecha
                    })
                } else if (dato.id_variable == 3) {
                    this.datosTemperaturaFiltrados3.push({
                        y: dato.temperatura,
                        x: dato.fecha
                    })
                } else if (dato.id_variable == 4) {
                    this.datosTemperaturaFiltrados4.push({
                        y: dato.temperatura,
                        x: dato.fecha
                    })
                } else if (dato.id_variable == 5) {
                    this.datosTemperaturaFiltrados5.push({
                        y: dato.temperatura,
                        x: dato.fecha
                    })
                } else if (dato.id_variable == 6) {
                    this.datosTemperaturaFiltrados6.push({
                        y: dato.temperatura,
                        x: dato.fecha
                    })
                }
            }) 
            this.loading = false
            } catch (error) {
                console.error('Error al obtener temperaturas por rango:', error.message);
            }
               
        },
        async filtrarAlarmas(){            
            if (!this.fechaInicioAlarma || !this.fechaFinAlarma) {
                return;
            }
            try {
                this.loading = true
                const inicioMadrid = moment.tz(
                `${this.fechaInicioAlarma} ${this.horaInicioAlarma || "00:00"}`,
                "YYYY-MM-DD HH:mm",
                "Europe/Madrid"
            );

            const finMadrid = moment.tz(
                `${this.fechaFinAlarma} ${this.horaFinAlarma || "23:59"}`,
                "YYYY-MM-DD HH:mm",
                "Europe/Madrid"
            );
            const fechaInicioUTC = inicioMadrid.toISOString(); // objeto Date en UTC
            const fechaFinUTC = finMadrid.toISOString();                    
                this.loading = true
                const response = await  this.getHistoricosAlarmasByRange( {
                    fechaInicio: fechaInicioUTC,
                    fechaFin: fechaFinUTC,
                });
                  
            this.historicoAlarmas = response.data.map(item => ({
                id: item.id,
                valor: item.alarma,
                fecha: new Date(item.read_at),
                descripcion: item.descripcion
                }));
            this.historicoAlarmasFiltrado = [...this.historicoAlarmas]
            this.loading = false
            } catch (error) {
                console.error('Error al obtener alarmas por rango:', error.message);
            }
        },
        formatearFechaHora(fecha) {
            const date = new Date(fecha);

            const dia = String(date.getDate()).padStart(2, '0');
            const mes = String(date.getMonth() + 1).padStart(2, '0'); // Enero es 0
            const anio = date.getFullYear();

            const horas = String(date.getHours()).padStart(2, '0');
            const minutos = String(date.getMinutes()).padStart(2, '0');
            const segundos = String(date.getSeconds()).padStart(2, '0');

            return `${dia}/${mes}/${anio} ${horas}:${minutos}:${segundos}`;
        }
    },
    created() {
        this.pantalla = document.documentElement.clientWidth
    },
        
}
</script>
<style scoped>
.v-card {
    height: 400px;
  }
  html,
body {
  overflow-x: hidden !important;
}

</style>